// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-HR-HRSettings-___EditList-module__cellUpdateRank {
  height: 100%;
  width: 100%;
  cursor: ns-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;
}

.app-pages-HR-HRSettings-___EditList-module__container .react-draggable.react-draggable-dragging {
  background-color: #fff;
  z-index: 2;
}

.app-pages-HR-HRSettings-___EditList-module__item {
  width: 100%;
  height: 100%;
  display: flex;
  align-content: space-around;
}

.app-pages-HR-HRSettings-___EditList-module__item.app-pages-HR-HRSettings-___EditList-module__multipleItems {
  display: flex;
}
.app-pages-HR-HRSettings-___EditList-module__item.app-pages-HR-HRSettings-___EditList-module__multipleItems > div {
  border-right: var(--mainBorder);
}

.app-pages-HR-HRSettings-___EditList-module__autoSizes > div:first-child {
  min-width: 300px;
  max-width: 400px;
}

.app-pages-HR-HRSettings-___EditList-module__autoSizes > div:nth-child(2) {
  max-width: 150px;
}

.app-pages-HR-HRSettings-___EditList-module__autoSizes > div:nth-child(3) {
  min-width: 300px;
  max-width: 400px;
}

.app-pages-HR-HRSettings-___EditList-module__autoSizes > div:last-child {
  max-width: 100px;
}

.app-pages-HR-HRSettings-___EditList-module__itemCell {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  text-align: center;
  flex-wrap: wrap;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  width: 100%;
  min-height: 35px;
  flex: 1;
  padding: 2px;
}

.app-pages-HR-HRSettings-___EditList-module__title {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.app-pages-HR-HRSettings-___EditList-module__sortIndicator {
  height: 100%;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
}

/* .tableItem {
  position: relative;
  margin: 2px;
  background-color: #555;
  color: #fff;
  padding: 3px 7px;
  border-radius: 3px;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  white-space: nowrap;
} */
`, "",{"version":3,"sources":["webpack://./app/pages/HR/HRSettings/EditList.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;;;;;;;;;;;;GAYG","sourcesContent":[".cellUpdateRank {\n  height: 100%;\n  width: 100%;\n  cursor: ns-resize;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: all;\n}\n\n.container :global(.react-draggable.react-draggable-dragging) {\n  background-color: #fff;\n  z-index: 2;\n}\n\n.item {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-content: space-around;\n}\n\n.item.multipleItems {\n  display: flex;\n}\n.item.multipleItems > div {\n  border-right: var(--mainBorder);\n}\n\n.autoSizes > div:first-child {\n  min-width: 300px;\n  max-width: 400px;\n}\n\n.autoSizes > div:nth-child(2) {\n  max-width: 150px;\n}\n\n.autoSizes > div:nth-child(3) {\n  min-width: 300px;\n  max-width: 400px;\n}\n\n.autoSizes > div:last-child {\n  max-width: 100px;\n}\n\n.itemCell {\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  text-align: center;\n  flex-wrap: wrap;\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  word-break: break-word;\n  width: 100%;\n  min-height: 35px;\n  flex: 1;\n  padding: 2px;\n}\n\n.title {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n}\n\n.sortIndicator {\n  height: 100%;\n  width: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  right: 0;\n}\n\n/* .tableItem {\n  position: relative;\n  margin: 2px;\n  background-color: #555;\n  color: #fff;\n  padding: 3px 7px;\n  border-radius: 3px;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  white-space: nowrap;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cellUpdateRank": `app-pages-HR-HRSettings-___EditList-module__cellUpdateRank`,
	"container": `app-pages-HR-HRSettings-___EditList-module__container`,
	"item": `app-pages-HR-HRSettings-___EditList-module__item`,
	"multipleItems": `app-pages-HR-HRSettings-___EditList-module__multipleItems`,
	"autoSizes": `app-pages-HR-HRSettings-___EditList-module__autoSizes`,
	"itemCell": `app-pages-HR-HRSettings-___EditList-module__itemCell`,
	"title": `app-pages-HR-HRSettings-___EditList-module__title`,
	"sortIndicator": `app-pages-HR-HRSettings-___EditList-module__sortIndicator`
};
export default ___CSS_LOADER_EXPORT___;
